import React, { useEffect, useMemo, useState } from "react";
import "./History.css";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";

export default function History() {
  const [bets, setBets] = useState([]);
  const [openDate, setOpenDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("closed");
  const [search, setSearch] = useState("");
  const [period, setPeriod] = useState("24h");
  const [showFilter, setShowFilter] = useState(false);

  const username = localStorage.getItem("username");

  useEffect(() => {
    loadHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function loadHistory() {
    try {
      setLoading(true);

      if (!username) {
        setBets([]);
        return;
      }

      // Collections zinazotumiwa na BetPlace.js pekee
      const collectionNames = [
        "otherbetantscore",
        "otherbetcorectscore",
      ];

      const snapshots = await Promise.all(
        collectionNames.map((name) =>
          getDocs(
            query(
              collection(db, name),
              where("username", "==", username)
            )
          )
        )
      );

      const scoreTypes = {
        otherbetantscore: "SCORE",
        otherbetcorectscore: "SCORE",
      };

      let all = snapshots.flatMap((snapshot, index) => {
        const collectionName = collectionNames[index];

        return snapshot.docs.map((item) => {
          const data = item.data();

          return {
            id: item.id,
            ...data,
            collectionName,
            scoreType: scoreTypes[collectionName],
            result: String(
              data.result || data.status || "pending"
            ).toLowerCase(),
          };
        });
      });

      // Tafuta matokeo ya mechi kwenye matches
      const matchesSnapshot = await getDocs(
        collection(db, "matches")
      );

      const matches = matchesSnapshot.docs.map((item) => ({
        id: item.id,
        ...item.data(),
      }));

      all = all.map((bet) => {
        const matchId =
          bet.matchId ||
          bet.matchID ||
          bet.match?.id ||
          bet.match_id ||
          null;

        let foundMatch = matchId
          ? matches.find(
              (match) => String(match.id) === String(matchId)
            )
          : null;

        // Ikiwa match ID haijapatikana, tumia majina ya timu na tarehe
        if (!foundMatch) {
          const teamA = String(
            bet.teamA || bet.A || ""
          ).trim().toLowerCase();

          const teamB = String(
            bet.teamB || bet.B || ""
          ).trim().toLowerCase();

          const matchDate = String(
            bet.matchDate || bet.date || ""
          ).trim();

          foundMatch = matches.find((match) => {
            const matchTeamA = String(
              match.teamA || match.A || ""
            ).trim().toLowerCase();

            const matchTeamB = String(
              match.teamB || match.B || ""
            ).trim().toLowerCase();

            const date = String(match.date || "").trim();

            return (
              teamA === matchTeamA &&
              teamB === matchTeamB &&
              (!matchDate || !date || matchDate === date)
            );
          });
        }

        const finalScore = foundMatch?.finalScore;

        return {
          ...bet,
          finalScore:
            finalScore !== undefined &&
            finalScore !== null &&
            String(finalScore).trim() !== ""
              ? String(finalScore).trim()
              : null,
        };
      });

      // Bet mpya ziwe juu
      all.sort((a, b) => {
        const dateA = a.createdAt?.toDate
          ? a.createdAt.toDate()
          : new Date(a.createdAt || 0);

        const dateB = b.createdAt?.toDate
          ? b.createdAt.toDate()
          : new Date(b.createdAt || 0);

        return dateB - dateA;
      });

      setBets(all);
    } catch (error) {
      console.error("History load error:", error);
      setBets([]);
    } finally {
      setLoading(false);
    }
  }

  function getCreatedDate(bet) {
    if (!bet.createdAt) return null;

    const date = bet.createdAt?.toDate
      ? bet.createdAt.toDate()
      : new Date(bet.createdAt);

    return Number.isNaN(date.getTime()) ? null : date;
  }

  function formatDate(date) {
    if (!date) return "-";

    const d = date?.toDate ? date.toDate() : new Date(date);

    if (Number.isNaN(d.getTime())) return "-";

    return `${d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    })} ${d.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}`;
  }

  function isWithinPeriod(bet) {
    const created = getCreatedDate(bet);
    if (!created) return period === "all";

    const now = new Date();
    const day = 24 * 60 * 60 * 1000;
    const diff = now.getTime() - created.getTime();

    switch (tab) {
      case "closed":
        return diff >= 0 && diff <= 7 * day;

      case "open":
        return diff > 7 * day && diff <= 14 * day;

      case "pending":
        return (
          created.getMonth() === now.getMonth() &&
          created.getFullYear() === now.getFullYear()
        );

      case "lastMonth": {
        const lastMonth = new Date(
          now.getFullYear(),
          now.getMonth() - 1,
          1
        );

        return (
          created.getMonth() === lastMonth.getMonth() &&
          created.getFullYear() === lastMonth.getFullYear()
        );
      }

      default:
        return true;
    }
  }

  const filtered = useMemo(() => {
    const now = new Date();
    const day = 24 * 60 * 60 * 1000;

    return bets
      .filter((bet) => {
        const created = getCreatedDate(bet);

        if (!created) return period === "all";

        const diff = now.getTime() - created.getTime();

        switch (period) {
          case "24h":
            return diff >= 0 && diff <= day;

          case "7d":
            return diff >= 0 && diff <= 7 * day;

          case "30d":
            return diff >= 0 && diff <= 30 * day;

          default:
            return true;
        }
      })
      .filter(isWithinPeriod)
      // Usiondoe pending: onyesha pending, win na lose
      .filter((bet) => {
        const result = String(
          bet.result || bet.status || "pending"
        ).toLowerCase();

        return ["pending", "win", "lose"].includes(result);
      })
      .filter((bet) =>
        [
          bet.teamA,
          bet.teamB,
          bet.league,
          bet.betId,
          bet.score,
          bet.scoreType,
          bet.finalScore,
          bet.collectionName,
          bet.result,
          bet.status,
        ]
          .join(" ")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
  }, [bets, tab, search, period]);

  const grouped = useMemo(() => {
    const result = {};

    filtered.forEach((bet) => {
      const date = getCreatedDate(bet);
      if (!date) return;

      const key = [
        String(date.getDate()).padStart(2, "0"),
        String(date.getMonth() + 1).padStart(2, "0"),
        date.getFullYear(),
      ].join("-");

      if (!result[key]) result[key] = [];
      result[key].push(bet);
    });

    return result;
  }, [filtered]);

  const grandStake = filtered.reduce(
    (total, bet) => total + Number(bet.amount || bet.stake || 0),
    0
  );

  const grandProfit = filtered.reduce((total, bet) => {
    const amount = Number(bet.amount || bet.stake || 0);
    const profit = Number(bet.profit || 0);
    const result = String(
      bet.result || bet.status || "pending"
    ).toLowerCase();

    if (result === "win") return total + profit;
    if (result === "lose") return total - (amount + profit);

    return total;
  }, 0);

  function formatMoney(value) {
    return Number(value || 0).toLocaleString("en-GB", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  function getResult(bet) {
    return String(
      bet.result || bet.status || "pending"
    ).toLowerCase();
  }

  function getResultLabel(bet) {
    const result = getResult(bet);

    if (result === "win") return "WIN";
    if (result === "lose") return "LOSE";
    return "PENDING";
  }

  function getMarketLabel(bet) {
    // These two History collections are both displayed as SCORE.
    if (
      bet.collectionName === "otherbetantscore" ||
      bet.collectionName === "otherbetcorectscore"
    ) {
      return "SCORE";
    }

    const market = String(bet.prediction || bet.mode || "").trim();
    if (/ant|unsecured\s*score|secured\s*score|score|otherbetantscore|otherbetcorectscore/i.test(market)) {
      return "SCORE";
    }
    return market || "SCORE";
  }

  function getPotentialProfit(bet) {
    const amount = Number(bet.amount || bet.stake || 0);
    const percentage = Number(bet.odds ?? bet.percentage ?? 0);
    if (Number.isFinite(percentage) && percentage > 0) {
      return (amount * percentage) / 100;
    }
    return Number(bet.profit || 0);
  }

  return (
    <div className="history-page">
      <div className="history-header">
        <h2>Bet History</h2>

        <button
          type="button"
          className="history-filter-btn"
          onClick={() => setShowFilter(!showFilter)}
        >
          Filter
        </button>
      </div>

      {showFilter && (
        <div className="history-filter-box">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
          >
            <option value="24h">Last 24 Hours</option>
            <option value="7d">Last 7 Days</option>
            <option value="30d">Last 30 Days</option>
            <option value="all">All</option>
          </select>
        </div>
      )}

      <div className="history-tabs">
        {[
          ["closed", "WIKI HII"],
          ["open", "WIKI ILIYOPITA"],
          ["pending", "MWEZI HUU"],
          ["lastMonth", "MWEZI ULIOPITA"],
        ].map(([value, label]) => (
          <button
            type="button"
            key={value}
            className={tab === value ? "active" : ""}
            onClick={() => setTab(value)}
          >
            {label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="loading-dots">
          <span />
          <span />
          <span />
        </div>
      ) : filtered.length === 0 ? (
        <div className="history-empty">
          No History Found
        </div>
      ) : (
        <div className="history-list">
          <div className="history-table-head">
            <span>Tarehe</span>
            <span>Jumla ya miamala halali</span>
            <span>Jumla ya mapato</span>
            <span />
          </div>

          {Object.entries(grouped).map(([date, dayBets]) => {
            const totalStake = dayBets.reduce(
              (total, bet) =>
                total + Number(bet.amount || bet.stake || 0),
              0
            );

            const totalProfit = dayBets.reduce((total, bet) => {
              const amount = Number(bet.amount || bet.stake || 0);
              const profit = Number(bet.profit || 0);
              const result = getResult(bet);

              if (result === "win") return total + profit;
              if (result === "lose") return total - (amount + profit);

              return total;
            }, 0);

            return (
              <div key={date} className="history-day">
                <div className="history-day-header">
                  <span>{date}</span>
                  <span>{formatMoney(totalStake)}</span>

                  <span
                    className={totalProfit >= 0 ? "green" : "red"}
                  >
                    {formatMoney(totalProfit)}
                  </span>

                  <button
                    type="button"
                    className="history-arrow"
                    onClick={() =>
                      setOpenDate(openDate === date ? "" : date)
                    }
                  >
                    {openDate === date ? "▼" : ">"}
                  </button>
                </div>

                {openDate === date && (
                  <div className="history-details">
                    {dayBets.map((bet) => {
                      const result = getResult(bet);
                      const amount = Number(
                        bet.amount || bet.stake || 0
                      );
                      const profit = getPotentialProfit(bet);
                      const totalWin = amount + profit;

                      return (
                        <div
                          key={`${bet.collectionName}-${bet.id}`}
                          className="history-detail-card"
                        >
                          <h4>
                            {bet.matchDate || "-"}{" "}
                            {bet.matchTime || ""}
                            <br />
                            {bet.league || "League"}
                          </h4>

                          <div className="match-row">
                            <strong>
                              {bet.teamA || bet.A || "Team A"}
                            </strong>
                            <span>{bet.score || "—"}</span>
                            <strong>
                              {bet.teamB || bet.B || "Team B"}
                            </strong>
                          </div>

                          <div className="score-type-box">
                            <div className="score-type-label">
                              SCORE
                            </div>
                            <div className="score-type-value">
                              {bet.score || "—"}
                            </div>
                          </div>

                          <div className="detail-line">
                            <span>Bet ID</span>
                            <span>{bet.betId || bet.id}</span>
                          </div>

                          <div className="detail-line">
                            <span>Betting Time</span>
                            <span>{formatDate(bet.createdAt)}</span>
                          </div>

                          <div className="detail-line">
                            <span>Market</span>
                            <span>
                              {getMarketLabel(bet)}{" "}
                              @{bet.odds ?? bet.percentage ?? "—"}%
                            </span>
                          </div>

                          {bet.finalScore && (
                            <div className="detail-line final-score-line">
                              <span>Final Score</span>
                              <span>{bet.finalScore}</span>
                            </div>
                          )}

                          <div className="detail-line">
                            <span>Stake</span>
                            <span>
                              {bet.currency || ""}{" "}
                              {formatMoney(amount)}
                            </span>
                          </div>

                          <div className="detail-line">
                            <span>Result</span>
                            <span
                              className={
                                result === "win"
                                  ? "green"
                                  : result === "lose"
                                  ? "red"
                                  : ""
                              }
                            >
                              {getResultLabel(bet)}
                            </span>
                          </div>

                          <div className="detail-line blue">
                            <span>Potential Profit</span>
                            <span>
                              {bet.currency || ""}{" "}
                              {formatMoney(profit)}
                            </span>
                          </div>

                          <div
                            className={
                              "detail-line " +
                              (result === "win"
                                ? "green"
                                : result === "lose"
                                ? "red"
                                : "")
                            }
                          >
                            <span>
                              {result === "pending"
                                ? "Potential Total Return"
                                : "Total Return"}
                            </span>
                            <span>
                              {bet.currency || ""}{" "}
                              {formatMoney(
                                result === "lose" ? 0 : totalWin
                              )}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}

          <div className="history-total-row">
            <span>Jumla</span>
            <span>{formatMoney(grandStake)}</span>
            <span
              className={grandProfit >= 0 ? "green" : "red"}
            >
              {formatMoney(grandProfit)}
            </span>
            <span />
          </div>
        </div>
      )}
    </div>
  );
}
